import { motion } from "framer-motion";
import { STATS } from "@/data/site";

export const Stats = () => (
  <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-mh-line border border-mh-line">
      {STATS.map((s, i) => (
        <motion.div
          key={s.label}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: i * 0.1 }}
          className="bg-mh-bg p-8 lg:p-10"
          data-testid={`stat-${i}`}
        >
          <div className="font-display font-black text-4xl lg:text-5xl text-white tracking-tight">{s.value}</div>
          <div className="mt-2 text-xs tracking-[0.2em] uppercase text-mh-slate">{s.label}</div>
        </motion.div>
      ))}
    </div>
  </section>
);
